import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import Chart from 'assets/livenicons/plan_designed1.svg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';
import { format, addMonths } from 'date-fns';

import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const PlanDesigned: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  const generateFutureDate = (monthsToAdd: number) => {
    return format(addMonths(new Date(), monthsToAdd), 'MMMM yyyy');
  };

  const generateCurrentMonth = (monthsToAdd: number) => {
    return format(addMonths(new Date(), monthsToAdd), 'MMMM');
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        A plan designed to support your wellbeing jorney
      </h3>
      <p className={styles.description}>
        Based on your answers, we expect you to decrease your negative effects
        level by
      </p>
      <p className={styles.month}>{generateFutureDate(2)}</p>
      <div className={styles.content}>
        <img src={Chart} alt="" />
        <div className={styles.labelsWrapper}>
          <p>{generateCurrentMonth(0)}</p>
          <p>{generateCurrentMonth(2)}</p>
        </div>
        <p className={styles.info}>
          The chart is a non-customized illustration and results may vary.
        </p>
      </div>
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
